// Print out version first
import packageJson from "../package.json";
console.log(packageJson.version);

import "bootstrap/dist/js/bootstrap.bundle.min";

import * as React from "react";
import * as ReactDOM from "react-dom";
import { IconContext } from "react-icons";
import { LocalizeProvider } from "react-localize-redux";
import App from "./components/App";
import "./index.scss";
import { unregister } from "./registerServiceWorker";

ReactDOM.render(
  <LocalizeProvider>
    <IconContext.Provider value={{ className: "react-icon" }}>
      <App />
    </IconContext.Provider>
  </LocalizeProvider>,
  document.getElementById("root") as HTMLElement
);
unregister();
